import { ModalOverlay, ModalDialog, Button } from '@flos/react-ui';

import { useConfigContext } from '../../context/ConfigContext';
import { ProductNames } from '../../interfaces/interfaces';
import { RenderHtml } from '../../components/shared/RenderHtml';

interface IProps {
    show: boolean;
    strings: Record<string, string>;
    amount: string;
    closeHandler: Function;
}

const GiftcardModal = ({ show, strings, amount, closeHandler }: IProps): JSX.Element => {
    const { product } = useConfigContext();
    const handleDismiss = () => {
        closeHandler();
    };

    const getUserFriendlyProductName = (product: ProductNames): string => {
        switch (product) {
            case ProductNames.CAR:
                return 'bilforsikring';
            case ProductNames.CHILD:
                return 'boerneforsikring';
            default:
                return 'forsikring';
        }
    };

    return (
        <>
            <ModalOverlay isOpen={show} onDismiss={() => handleDismiss()} id="modal-dialog">
                <ModalDialog position="center" closeIconHandler={() => handleDismiss()}>
                    <div className="u-spacing-inset-xl">
                        <div className={'u-flex-box u-flex-box--space-between u-spacing-stack-l'}>
                            <h3 className="u-spacing-stack-none">SuperGavekort fra GoGift</h3>
                        </div>

                        <RenderHtml>
                            {strings['shoppingcart.expand']
                                .replace('{amount}', Intl.NumberFormat('da-DK').format(parseInt(amount)))
                                .replace('{product}', getUserFriendlyProductName(product))
                                .replace('{the_product}', `${getUserFriendlyProductName(product)}en`)}
                        </RenderHtml>

                        <Button className="flos-button flos-button--secondary" onClick={() => handleDismiss()}>
                            Tilbage
                        </Button>
                    </div>
                </ModalDialog>
            </ModalOverlay>
        </>
    );
};

export default GiftcardModal;
